import i18n, { t } from 'i18next'

import { TPolicyLinkBlock } from '@/components/policyLinkBlock/types'

const POLICY_LINK: Record<string, string> = {
  tos: 'https://great-apps.zendesk.com/hc/en-us/articles/28321178482577-Terms-of-Service',
  privacyPolicy: 'https://great-apps.zendesk.com/hc/en-us/articles/28319992746129-Privacy-Policy',
  refundPolicy: 'https://great-apps.zendesk.com/hc/en-us/articles/28320539101713-Refund-Policy',
}

interface IPolicy {
  defaultPolicyTemplate: TPolicyLinkBlock
  translationKey: string | undefined
}

export const getPolicy = ({ translationKey, defaultPolicyTemplate }: IPolicy) => {
  const policyTemplate: TPolicyLinkBlock =
    i18n.isInitialized && translationKey
      ? t(translationKey, { returnObjects: true, defaultValue: defaultPolicyTemplate })
      : defaultPolicyTemplate

  return policyTemplate?.text
    .replace(
      '{tos}',
      `<a href="${POLICY_LINK.tos}" target="_blank" rel="noopener noreferrer">${policyTemplate?.tos}</a>`
    )
    .replace(
      '{privacyPolicy}',
      `<a href="${POLICY_LINK.privacyPolicy}" target="_blank" rel="noopener noreferrer">${policyTemplate?.privacyPolicy}</a>`
    )
    .replace(
      '{refundPolicy}',
      `<a href="${POLICY_LINK.refundPolicy}" target="_blank" rel="noopener noreferrer">${policyTemplate?.refundPolicy}</a>`
    )
}
